/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	AnnotationStatus.js
 *
 * Description:	Encapsulates the Annotation Status JavaScript.
 *
 * History:		12-FEB-18	J Fuller		Initial implementation.
 *				30-JUL-18	P Dickson		Updated to pass through the session id.
 *				08-OCT-18   R Pavolas       Refactored bubble calls. (DR158989)
 *				20-JAN-20	S Norman		Ajax requests routing changed to use internal as part of UserStory 43113 - Upload Documents to Annotations.
 *
 */

(function () {
	"use strict";

	/**
	 * Prototype for holding an annotation Status.
	 */
	function AnnotationStatus() {
		this.id = -1;
		this.g_iApprovalUserAnnotId = 0;
		this.g_iAuthor = 0;
		this.g_szAuthorEmail = "";
		this.g_szAuthorDisplayName = "";
		this.g_iAnnotationStatus = 0;
		this.annotationStatusDateTime = null;
	};

	/*
	 *  - - - P U B L I C   M E T H O D S - - -
	 */

	/**
	 * Saves a new annotation save.
	 * @param {type} callerType
	 */
	AnnotationStatus.prototype.annotationSaveStatus = function (annotation) {
		
		// Copy the annotation and status.
		var oThisAnnotation = annotation;
		var oThisAnnotationStatus = this;

		// Create the annotation status object.
		var oAnnotationStatus = {
			annotationId: oThisAnnotationStatus.g_iApprovalUserAnnotId,
			approvalUserId: oThisAnnotationStatus.g_iAuthor,
			annotationStatus: oThisAnnotationStatus.g_iAnnotationStatus,
			annotationStatusDateTime: "",
			annotationstatusId: oThisAnnotationStatus.id
		};

		// Build up the JSON object.
		var oJSON = {
			szSessionId: g_oAnnotations.c_szSessionId,
			iUserId: g_oUserDetails.UserId,
			oAnnotationStatus: oAnnotationStatus
		};

		// Send the annotation to the server.
		$.ajax({
			type: "POST",
			url: "internal/GreenlightAnnotation/SaveAnnotationStatus",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {

				// Redraw the annotations.
				g_oAnnotations.g_oAnnotationViewer.redraw(false);

				// Remove list delete icon.
				$("#li_" + oThisAnnotationStatus.g_iApprovalUserAnnotId + "_del").remove();

				// Remove the delete icon from the bubble.
				if ($("#" + oThisAnnotationStatus.g_iApprovalUserAnnotId + "_del").length > 0) {
					$("#" + oThisAnnotationStatus.g_iApprovalUserAnnotId + "_del").remove();
				}

				// Close any open delete confirmation bubbles.
				if (g_oActiveBubbles.length > 0) {
					// Find the confirm bubble.
					for (var i = 0; i < g_oActiveBubbles.length; i++) {
						if (g_oActiveBubbles[i].type == "Confirm") {
							g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
							break;
						}
					}
				}

				// Update the id of the annotation status.
				oThisAnnotationStatus.updateAnnotationStatusId(response, oThisAnnotationStatus.id);

				// If this is an svg text annotation.
				if (oThisAnnotation.g_bSVGTextAnnotation) {

					// Update the svg text based on the status.
					g_oSVGText.applySVGStatusUpdate(oThisAnnotation);
				}

				// Display the success bubble.
				g_oGreenlightMessages.displaySuccessBubble(g_oAnnotations.c_szAnnotationStatusSavedSuccessfully);

				// Push this change to other users.
				g_oAnnotations.g_oAnnotationHub.server.send(g_oAnnotations.g_iApprovalId, g_oUserDetails.EmailAddress);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
			}
		});
	};

	/**
	 * Removes an annotation status from an annotation.
	 * @param {object} annotation - The annotation to have the status removed from.
	 * @param {int} statusId - The id of the status to be deleted.
	 * @param {object} artworkCanvas - The artwork canvas.
	 * @param {object} annotationCanvas - The annotation canvas.
	 * @param {bool} rebuildAnnotationList - If the annotation list should be rebuilt.
	 * @param {bool} updateSVGText - If we should update any svg text.
	 */
	AnnotationStatus.prototype.deleteAnnotationStatus = function (annotation, statusId, artworkCanvas, annotationCanvas, rebuildAnnotationList, showSuccessBubble, updateSVGText) {

		// Determine the position of the reply to be removed.
		var iArrayReplyPosition = -1;
		for (var i = 0; i < annotation.g_oStatuses.length; i++) {
			if (annotation.g_oStatuses[i].id == statusId) {
				iArrayReplyPosition = i;
				break;
			}
		}

		// If we have failed to get a valid position, return.
		if (iArrayReplyPosition == -1) {
			return;
		}

		// Get the information for the annotation status to be deleted.
		var oJSON = {
			sessionId: g_oAnnotations.c_szSessionId,
			annotationId: annotation.id,
			userId: g_oUserDetails.UserId,
			annotationStatusId: annotation.g_oStatuses[iArrayReplyPosition].id,
			annotationStatusCode: annotation.g_oStatuses[iArrayReplyPosition].g_iAnnotationStatus
		};

		// Send to the server.
		$.ajax({
			type: "DELETE",
			url: "internal/GreenlightAnnotation/DeleteAnnotationStatus",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			success: function () {
				
				// Remove the status from the JavaScript.
				annotation.g_oStatuses.splice(iArrayReplyPosition, 1);

				// Clean up the annotation popup if it exists.
				if ($("#sc_" + annotation.id).length) {

					// Remove this annotation status from the bubble.
					if ($("#sc_" + annotation.id).find(".status[data-authorid='" + g_oUserDetails.UserId + "']").length) {
						$("#sc_" + annotation.id).find(".status[data-authorid='" + g_oUserDetails.UserId + "']").parent().remove();
					}

					// Re-add the delete button if we can.
					if (g_oAnnotations.canAnnotationBeDeleted(annotation.id)) {
						g_oAnnotations.insertDeleteButton(annotation.id);
					}
				}

				// Re-build the annotation list if required.
				if (rebuildAnnotationList) {
					g_oAnnotations.rebuildAnnotationList(artworkCanvas, annotationCanvas);
				}

				// If this is an svg text annotation.
				if (updateSVGText && annotation.g_bSVGTextAnnotation) {

					// Update the svg text based on the status.
					g_oSVGText.applySVGStatusUpdate(annotation);
				}

				// Display the success message if required.
				if (showSuccessBubble) {
					g_oGreenlightMessages.displaySuccessBubble(g_oAnnotations.c_szAnnotationStatusDeletedSuccessfully);
				}

				// Push this change to other users.
				g_oAnnotations.g_oAnnotationHub.server.send(g_oAnnotations.g_iApprovalId, g_oUserDetails.EmailAddress);
			},
			failure: function () {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationStatusDeletedFail);
			},
			error: function () {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationStatusDeletedFail);
			}
		});
	};

	/**
	 * Updates an annotation status Id after saving.
	 * @param {object} response - The JSON content object.
	 * @param {int} tempId - The (possibly) temporary Id given to the status.
	 */
	AnnotationStatus.prototype.updateAnnotationStatusId = function (response, tempId) {
		var oReturnedStatus = JSON.parse(response.Contents);
		var that = this;
		// Find the annotation the status belongs to.
		var oMatchingAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id == that.g_iApprovalUserAnnotId; });

		for (var i = 0; i < oMatchingAnnotation[0].g_oStatuses.length; i++) {
			if (oMatchingAnnotation[0].g_oStatuses[i].id == tempId) {
				oMatchingAnnotation[0].g_oStatuses[i].id = oReturnedStatus.annotationstatusId;
				break;
			}
		}
	};

	// Add the Annotation UI object to the window.
	window.AnnotationStatus = AnnotationStatus;

}());